export class EmployeeSkillMatrixDTO {
    employeeSkillMatrixId: number;
    machineWise: string;
    needleType: boolean;
    needleBarAdjustment: boolean;
    hookSetLooperTimings: boolean;
    stitchingAdjustment: boolean;
    uBTriming: boolean;
    feedTiming: boolean;
    programSetting: boolean;
    lubricationSystem: boolean;
    pullerAssembly: boolean;
    splitBarMechanism: boolean;
    gaugeSetReplacement: boolean;
    looperThreadTakeUpCamTiming: boolean;
    needleGaurdAdjustment: boolean;
    folderAttachementSettingBasic: boolean;
    snapDieFixing: boolean;
    safetyRequirements: boolean;
    preventiveMaintenance: boolean;
    OfSkillAquired: number;
    constructor(employeeSkillMatrixId: number,
        machineWise: string,
        needleType: boolean,
        needleBarAdjustment: boolean,
        hookSetLooperTimings: boolean,
        stitchingAdjustment: boolean,
        uBTriming: boolean,
        feedTiming: boolean,
        programSetting: boolean,
        lubricationSystem: boolean,
        pullerAssembly: boolean,
        splitBarMechanism: boolean,
        gaugeSetReplacement: boolean,
        looperThreadTakeUpCamTiming: boolean,
        needleGaurdAdjustment: boolean,
        folderAttachementSettingBasic: boolean,
        snapDieFixing: boolean,
        safetyRequirements: boolean,
        preventiveMaintenance: boolean,
        OfSkillAquired: number
    ) {
        this.employeeSkillMatrixId = employeeSkillMatrixId;
        this.machineWise = machineWise;
        this.needleType =needleType;
        this.needleBarAdjustment=needleBarAdjustment;
        this.hookSetLooperTimings = hookSetLooperTimings;
        this.stitchingAdjustment = stitchingAdjustment;
        this.uBTriming = uBTriming;
        this.feedTiming = feedTiming;
        this.programSetting = programSetting;
        this.lubricationSystem = lubricationSystem;
        this.pullerAssembly =pullerAssembly;
        this.splitBarMechanism = splitBarMechanism;
        this.gaugeSetReplacement = gaugeSetReplacement;
        this.looperThreadTakeUpCamTiming = looperThreadTakeUpCamTiming;
        this.needleGaurdAdjustment = needleGaurdAdjustment;
        this.folderAttachementSettingBasic = folderAttachementSettingBasic;
        this.snapDieFixing = snapDieFixing;
        this.safetyRequirements = safetyRequirements;
        this.preventiveMaintenance = preventiveMaintenance;
        this.OfSkillAquired = OfSkillAquired;
    }
}
